<template>
    <div id="gallery-album">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>

        <div v-if="gallery">
            <h1 class="title has-text-centered mtb-80 is-size-1" >
                <span v-text="galleryName"></span>
            </h1>

                <div class="mtb-20 rel">
                    <form id="search" autocomplete="off" @submit.stop.prevent="submitPrevent($event)">
                        <input class="input searchInput" id="searchField" name="query" v-model="query" placeholder="Išči ..." @keyup="itemFilter">
                        <span v-if="query !==''" @click="clear" class="is-icon">
                            <i class="close">X</i>
                        </span>
                    </form>
                    <p class="has-text-danger has-text-right" :class="errorClass" v-if="searchError">Filter slike {{ query }}: {{ gallery.error | lowercase }} </p>

                    <div class="breadcrumbs-parent" style="left:20px; top:50px; display: flex;">
                        <ul>
                            <li><router-link to="/galerija">Galerija</router-link></li>
                            <li v-text="capitalize(album)"></li>
                        </ul>
                    </div>
                </div>
                <app-pagination :pagination="pagination" :endpoint="componentEndpoint" @click.native="getResults(pagination.current_page)" :offset="4">
                </app-pagination>

                <app-sb :photos="gallery.photos.data" albumId="photo-gallery" class="full-page"></app-sb>

                <app-pagination :endpoint="componentEndpoint" :pagination="pagination" @click.native="getResults(pagination.current_page)" :offset="4">
                </app-pagination>

        </div>
    </div>
</template>

<script>
import { ApiHome, PhotoUrl, baseUrl } from '../../.env';
import { mapGetters, mapActions } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';
import Silentbox from '../../components/elements/silentbox/SilentboxGallery.vue';
import Pagination from '../../components/elements/pagination/Pagination.vue';

export default {
    props: ['album', 'page'],
    mixins: [StringsMixin],

    data() {
        // console.log('ALBUM: ', this.album);
        return {
            endpoint: ApiHome+ 'gallery',
            endpointSearch: ApiHome + 'searchGallery',
            photoUrl: PhotoUrl,
            query: '',
            errorClass: '',
            size: '/1960/',
            albumName: 'Galerija slik',
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-sb': Silentbox,
        'app-back': BackButton,
        'app-pagination': Pagination,
    },

    computed: {
        ...mapGetters([
            'gallery',
            'loading',
            'error',
            'title',
            'paginate',
            'pagination',
        ]),

        imagePath() {
            // console.log('image path: ', PhotoUrl);
            return PhotoUrl + this.gallery.album_id + this.size;
        },

        galleryPhotos() {
            // console.log('gallery photos: ', this.gallery.photos);
            return this.gallery.photos;
        },

        galleryName() {
            if(typeof(this.title) !== 'undefined' || this.title !== '') {
                return this.capitalize(this.title);
            }
            if(typeof(this.album) !== 'undefined' || this.album !== '') {
                return this.capitalize(this.album);
            }
            return this.albumName;
        },

        componentEndpoint() {
            // console.log('gallery endpoint: ', '/gallery/' + this.album);
            if (typeof (this.album) === 'undefined') {
                return '/galerija/p';
            }
            return '/galerija/album/' + this.album ;
        },

        searchError() {
            if(this.query !== '' && this.gallery.error && this.gallery.error !== '') {
                // console.log(' error for filters ');
                this.errorClass = '';
                return true;
            }
            this.errorClass = 'is-hidden';
            return false;
        }
    },

    methods: {
        /**
         * get paginated results - for page > 1
         * paginate - navigation click
         */
        getResults(page) {
            if (typeof page === 'undefined') {
                page = 2;
            }
            let endpoint = this.endpoint;
            if (typeof (this.album) !== 'undefined') {
                // console.log('getResults - gallery IF: ', this.album, this.page);
                endpoint = this.endpoint + '/' + this.album;
            } else {
                // page = this.page;
                // endpoint = this.endpoint + '/p/' + page;
                alert('we should not be here getResults - gallery: ELSE '+ this.page + endpoint);
            }
            let data = {
                endpoint: endpoint,
                page: page,
                type: 'gallery',
                album: this.album,
                photo: ''
            };
            // console.log('gallery getResults: ', endpoint, ' page: ', page, 'this.page: ', this.page, ' album: ', this.album);
            this.$store.dispatch('getPaginatedItems', data);
        },

        fetchAlbumPhotos() {
            let endpoint = this.endpoint;

            let page = this.page;
            if(typeof(this.page) === 'undefined') {
                // console.log('PAGE undefined');
                page = 1;
            }

            let data = {
                endpoint: endpoint,
                page: page,
                type: 'gallery',
                album: '',
            };

            if( typeof(this.album) !== 'undefined') {
                // http://localhost:8090/galerija/album/ola/1

                endpoint = this.endpoint + '/' + this.album + '/' + page;

                data.endpoint = endpoint;
                data.album = this.album;
                // console.log('fetch gallery -  album: ', data, ' album: ', this.album, ' photo: ', this.photo);
            }
            else {
                // http://localhost:8090/galerija
                // endpoint = this.endpoint + '/p/' + page;
                // data.endpoint = endpoint;
                alert('should not be here !!!')
            }


            // console.log('PAGE undefined? ', data);
            this.$store.dispatch('fetchGallery', data);
        },

        clear() {
            this.query = '';
            this.$store.dispatch('clearNotification');
            this.$store.dispatch('clearError');
            this.fetchAlbumPhotos();
        },

        submitPrevent(event) {
            // console.log('prevent submit: ', event);
            event.stopPropagation();
            event.preventDefault();
            // return false;
        },

        /**
         * live search
         */
        itemFilter() {
            let self=this;
            if(self.query === '') {
                // console.log('empty query, fetch all photos for album: ', this.album, ' page: ', this.page);
                // this.fetchPhoto();
                this.fetchAlbumPhotos();
            }
            else {
                let first = 'name';
                let second = 'description';
                let third = '';

                // if(this.link === '/photos/') {
                    first = 'name';
                    second = 'album_id';
                    third = 'location_id';
                // }
                this.endpoint = this.endpointSearch;
                let data = {
                    field: [first,second],
                    value: self.query,
                    endpoint: this.endpoint
                };

                this.$store.dispatch('fetchGalleryFilter', data);
            }
        },
    },

    created() {
        this.itemFilter();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/gallery/GalleryAlbum.vue